let sub: string | null = null
let email: string | null = null
let username: string | null = null

export default class CognitoUser {
  public static get sub() {
    return sub
  }

  public static get email() {
    return email
  }

  public static get username() {
    return username
  }

  public static store(data: Record<string, string>) {
    sub = data.sub || null
    email = data.email || null
    username = data.username || null
  }

  public static logout() {
    sub = null
    email = null
    username = null
  }
}
